<template>
<div>
  <my-menu class="myMenu"></my-menu>
  <router-view></router-view>
  <my-footer></my-footer>
</div>
</template>

<script>
import menu from './menu'
import MyFooter from "./myFooter";
export default {
  components: {
      MyFooter,
    'my-menu': menu
  }
}
</script>
